import { ApiMethodCallback } from '../ApiMethod';
import { createErrorResult, createSuccessResult } from '../ApiMethodResponseCreator';
import { getExtensibilityState } from 'owa-addins-store';

export default async function getInitializationContextApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: any,
    callback: ApiMethodCallback
) {
    const { taskPanes } = getExtensibilityState();
    let initializationContext;
    [...taskPanes.values()].forEach(element => {
        if (element.hostItemIndex === hostItemIndex && element.initializationContext) {
            initializationContext = element.initializationContext;
        }
    });

    if (initializationContext) {
        callback(createSuccessResult(initializationContext));
    } else {
        callback(createErrorResult());
    }
}
